import { render, staticRenderFns } from "./RemindersArchive.vue?vue&type=template&id=7fc68353"
import script from "./RemindersArchive.vue?vue&type=script&lang=js"
export * from "./RemindersArchive.vue?vue&type=script&lang=js"
import style0 from "./RemindersArchive.vue?vue&type=style&index=0&id=7fc68353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports